import { IDiscountSetting } from 'features/cashier/services/types/api';

const CASH_INCENTIVE_DISCOUNT_SETTING: IDiscountSetting = { ownerPaidPercent: 100, staffPaidPercent: 0 };

/**
 * Resolve the discountSetting sent along with a cash/check incentive update.
 *
 * The API carries a single discountSetting for the whole discount amount, but the
 * amount sent here merges the ticket discount with the incentive. When the ticket
 * already has its own discount, its owner/staff split wins; the incentive-only case
 * stays fully owner-paid.
 */
export const resolveIncentiveDiscountSetting = (
  ticketDiscount: number,
  ticketDiscountSetting?: IDiscountSetting | null,
): IDiscountSetting => {
  if (ticketDiscount > 0 && ticketDiscountSetting) return ticketDiscountSetting;
  return CASH_INCENTIVE_DISCOUNT_SETTING;
};
